module.exports = __webpack_public_path__ + "2fbe79c3fe709889e86c615b25248e24.MP3";